import { ContactFormLinkUrl } from "../helper/ContactFormLink";

export function ContactFormLink({ children }: { children?: React.ReactNode }) {
  return (
    <a href={ContactFormLinkUrl} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}
